import React, { useCallback, useRef, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { ReactTable, Spinner, TextInput } from 'components'
import ApiHelper from 'helpers/ApiHelper'
import { validateDomain } from 'helpers/ApplicationHelper'

const TenantSearchTable = ({ id, allowCreate = true, onSubmit }) => {
  //  --- Variables ---
  const debounceRef = useRef()
  const [inputValue, setInputValue] = useState('')
  const [queryValue, setQueryValue] = useState('')
  const { data, isFetching } = useQuery(
    ['searchTenants', queryValue],
    async () => {
      const tenants = await ApiHelper.searchTenants(queryValue)

      const validated = validateDomain(queryValue)
      if (allowCreate && tenants.length < 1 && validated != null) {
        return [
          {
            name: <span>Add '{validated}'</span>,
            primaryDomain: validated,
            adminId: null,
            tenandId: null,
          },
        ]
      } else {
        return tenants
      }
    },
    { refetchOnWindowFocus: false, refetchOnMount: false, initialData: [] }
  )

  //  --- Functionality ---
  const updateFilterValue = useCallback((e) => {
    const value = e.target.value
    setInputValue(value)

    clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(() => {
      setQueryValue(value)
    }, 500)
  }, [])

  //  --- Response ---
  return (
    <div className="flex h-full flex-col space-y-4">
      <div className="flex flex-row">
        <TextInput
          className="w-full md:w-2/3 xl:w-1/2"
          onChange={updateFilterValue}
          value={inputValue}
          placeholder="Search tenants..."
        />
        {isFetching ? <Spinner /> : null}
      </div>
      <ReactTable
        columns={tableHeaders}
        data={data ? data : []}
        height={450}
        initialSort={{ id: 'id', desc: true }}
        removeFooter={true}
        rowOnClick={onSubmit}
      />
    </div>
  )
}

const tableHeaders = [
  // {
  //   Header: 'ID',
  //   i18n: 'indexObjects:objectUsersTable.id',
  //   accessor: 'tenantId',
  //   width: 70,
  // },
  {
    Header: 'Name',
    i18n: 'indexObjects:objectUsersTable.name',
    accessor: 'name',
    width: 240,
  },
  {
    Header: 'Name',
    i18n: 'indexObjects:objectUsersTable.name',
    accessor: 'primaryDomain',
    width: 100,
  },
]

export default TenantSearchTable
